// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import moment from 'moment';
import config from '../../../config';

// Services
import Services from '../../../services';

// Types
type $Props = $Translate;

type $State = {
  visible: boolean;
};

class CookiesView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  componentDidMount(): void {
    this.check();
  }

  check(): void {
    if (Services.Cookies.getItem('cookies') !== 'ok') {
      this.setState({
        visible: true,
      });
    }
  }

  hide(): void {
    const now: moment.Moment = moment();

    const expires: Date = now.add(
      3,
      'years',
    ).toDate();

    Services.Cookies.setItem(
      'cookies',
      'ok',
      {
        domain: `.${config.DOMAIN}`,
        expires,
      },
    );
    Services.Cookies.setItem(
      'cookies',
      'ok',
      {
        domain: config.DOMAIN,
        expires,
      },
    );

    this.setState({
      visible: false,
    });
  }

  render() {
    const {
      t,
    } = this.props;
    const {
      visible,
    } = this.state;

    return (visible ? (
      <div className={'fixed max-w-xs mx-auto bottom-2 left-0 right-0'}>
        <div className={'card p-3 flex justify-between items-center'}>
          <span className={'mr-3'}>
            {t('Cookies are used. OK?')}
          </span>
          <button
            className={'btn btn_secondary btn_outlined uppercase py-1 px-2'}
            onClick={() => this.hide()}
            type={'button'}
          >
            {t('Ok')}
          </button>
        </div>
      </div>
    ) : null);
  }
}

export default CookiesView;
